import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./OidcProvider";

/** Wraps any /admin/* route. Renders children only when the user is
 *  authenticated AND has isAdmin = true. Non-admins are redirected to
 *  / (the Toolkit landing surface). Unauthenticated users see the same
 *  "Signing in…" placeholder as ProtectedRoute. */
export function AdminRoute({ children }: { children: ReactNode }): JSX.Element {
  const { state } = useAuth();
  if (state.status === "authenticated") {
    if (state.user.isAdmin) return <>{children}</>;
    return <Navigate to="/" replace />;
  }
  return (
    <div className="flex h-screen items-center justify-center text-slate-500">
      Signing in…
    </div>
  );
}
